import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, FormControl, OutlinedInput, Input, GridList } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typo from '../../components/CustomTypo';
import LightButton from '../../components/ButtonCustom';
import { LinkRouter, LinkCTA } from '../../components/Link';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, CheckBoxComponent, DatePickerComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import { domainName } from '../../../portal.config';

const styles = theme => ({
    container: {
        paddingTop: theme.spacing(30),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
    },

    marginTop4x: {
        marginTop: theme.spacing(8),
    },
    formLogin: {
        marginTop: theme.spacing(4),
        backgroundColor: theme.palette.background.box,//'#ffffff1f',
        borderRadius: 10,
        padding: theme.spacing(5, 15, 15, 15),
    },

});
function RegisterVerificationView(props) {
    const { classes, t, language } = props;
    return (
        <PublicPage
            rightComponent={
                <Grid xs={12} item justify='center' container>

                    <Grid item container xs={12}>
                        <Grid xs={12} item container justify='center'>
                            {/* <Typo variant='h2' color='primary'>{t('btn_register')}</Typo> */}
                        </Grid>
                        <Grid xs={12} item container className={classes.marginTop4x}>
                            <Typo variant='h5' color={domainName == 'buyway' ? 'onPrimary' : 'primary'} >{t('authenticate')}</Typo>
                        </Grid>
                        <Grid xs={12} item container>
                            <Typo color={domainName == 'buyway' ? 'onPrimary' : 'primary'} variant='body2'>{t('otp_desc')}</Typo>
                        </Grid>
                        <Form
                            onSubmit={props.onSubmit}
                            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                                <Grid xs={12} container item className={classes.marginTop4x}>
                                    <Field
                                        name="verification_code"
                                        component={TextFieldComponent}
                                        placeholder={t('enter_your_otp')}
                                        isEdit={true}

                                        validate={validators.composeValidators(validators.mustBeNumber)}
                                    />
                                    <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                                        <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                                            <LinkCTA color='primary'
                                                onClick={props.onResend}>
                                                {t('resend_code')}
                                            </LinkCTA>
                                        </Grid>
                                    </Grid>

                                    <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                                        <LightButton color='primary' fullWidth onClick={handleSubmit}>{t('authenticate_and_sign_in')}</LightButton>
                                    </Grid>

                                </Grid>
                            )} />
                    </Grid>
                </Grid>
            } />
    );
}
export default withStyles(styles)(withTranslation()(RegisterVerificationView));